if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )

        activeMedia.loadContent();
        mediaSlider();
      }
    }
  );
}

/*
 * 商品詳細画像拡大用スライダー
 */
function mediaSlider() {
  const slideContainer = document.getElementById('product-media-slider');
  const prev = document.getElementById('product-media-prev');
  const next = document.getElementById('product-media-next');

  // display: none ではない（表示されている）imgタグのみを取得(WEB_0001-25346 display:none画像による不具合修正)
  const slides = Array.from(document.querySelectorAll('#product-media-slider > img')).filter((slide) => {
    return window.getComputedStyle(slide).display !== 'none';
  });

  const totalSlides = slides.length;

  // 表示する画像がない場合は処理を終了
  if (totalSlides === 0) {
    return;
  }

  const slideWidth = 100 / totalSlides;
  slideContainer.style.width = `${totalSlides * 100}%`;

  slides.forEach((slide) => {
    slide.style.width = `${slideWidth}%`;
  });

  let activeCount = 0;
  let count = 0;

  // スライダーの位置を更新する関数
  function updateSlidePosition() {
    slideContainer.style.transform = `translateX(-${count * slideWidth}%)`;
  }

  // 次の画像へ進む処理
  function nextClick() {
    count++;
    if (count >= totalSlides) {
      count = 0;
    }
    updateSlidePosition();
  }

  // 前の画像へ戻る処理
  function prevClick() {
    count--;
    if (count < 0) {
      count = totalSlides - 1;
    }
    updateSlidePosition();
  }

  // 初期状態で active クラスがついている画像の位置に合わせる
  slides.forEach((slide) => {
    if(slide.classList.contains('active')) {
      count = activeCount;
      updateSlidePosition();
    }
    activeCount++;
  });

  // 各ボタンにクリックイベントを設定
  next.addEventListener('click', () => {
    nextClick();
  });
  prev.addEventListener('click', () => {
    prevClick();
  });
}
